import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import OrderCancelManagementListWrap from '../../views/order/cancel/management/list/OrderCancelManagementListWrap';
import { orderActions } from '../../store/modules/order';
import {
  ORDER_CANCEL_MANAGEMENT_MODEL,
  ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
} from '../../store/modules/order/models';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';
import { INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE } from '../../constants/service/invalidMsg/orderInvalidMsg';
import { ORDER_CANCEL_ITEM_STATUS } from '../../constants/service/app/orderConstants';
import { checkIsNonSelectedList, asyncSimpleModal } from '../../lib/common';

class OrderCancelManagementContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { setData } = this.props;

    this.getList({
      searchOption: ORDER_CANCEL_MANAGEMENT_LIST_SEARCH_OPTION_MODEL,
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     *  검색 박스 초기화
     */
    setData({
      path: ['orderCancelManagement'],
      value: ORDER_CANCEL_MANAGEMENT_MODEL,
    });
  };

  getList = (data) => {
    const { orderCancelManagement, getOrderCancelManagementList } = this.props;
    const { orderCancelManagementList } = orderCancelManagement;

    getOrderCancelManagementList({
      ...orderCancelManagementList,
      ...data,
    });
  };

  /**
   *  전체 엑셀 다운로드
   */
  getAllListExcelDownload = () => {
    const { orderCancelManagement, getOrderCancelManagementAllListExcelDownload, adminInfo } = this.props;
    const { searchOption, filterOption } = orderCancelManagement.orderCancelManagementList;

    getOrderCancelManagementAllListExcelDownload({
      email: adminInfo.email,
      fileName: '취소관리 전체 리스트',
      searchOption,
      filterOption,
    });
  };

  /**
   *  선택 엑셀 다운로드
   */
  getSelectedListExcelDownload = () => {
    const { orderCancelManagement, getOrderCancelManagementSelectedListExcelDownload } = this.props;
    const { orderCancelManagementSelectedList, orderCancelManagementList } = orderCancelManagement;
    const { searchOption, filterOption } = orderCancelManagementList;

    if (!orderCancelManagementSelectedList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getOrderCancelManagementSelectedListExcelDownload({
      fileName: '취소관리 선택 리스트',
      searchOption,
      filterOption,
      selectedOrderItemList: orderCancelManagementSelectedList,
    });
  };

  /**
   * 상품 주문 취소 선택 callback
   */
  onCheckOrderItem = (list) => {
    const { setData } = this.props;

    setData({
      path: ['orderCancelManagement', 'orderCancelManagementSelectedList'],
      value: list,
    });
  };

  /**
   * 취소 거부 처리
   * [취소 요청(0)]
   */
  rejectOrderCancel = async () => {
    const { orderCancelManagement, toggleModal } = this.props;
    const { orderCancelManagementSelectedList, orderCancelManagementList } = orderCancelManagement;
    const { list } = orderCancelManagementList;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderCancelManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  상품 주문 취소 상태가 취소 요청(0)인 경우에만
     *  취소 거부 처리를 할 수 있음
     */
    const targetOrderCancelItemList = list.reduce((acc, item) => {
      if (
        orderCancelManagementSelectedList.includes(item.orderItemId) &&
        item.orderItemCancelStatus === ORDER_CANCEL_ITEM_STATUS.CANCEL_REQUEST
      ) {
        acc.push(item);
      }
      return acc;
    }, []);

    /**
     *  선택한 상품 주문서에 취소 요청(0)건이 없을 경우
     */
    if (!targetOrderCancelItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '취소 거부 처리',
        message: '취소 요청 상태의 주문만 적용할 수 있습니다.',
      });
      return;
    }

    /**
     *  취소 거부 처리를 위해 취소 거부 상세 사유를
     *  입력하는 모달을 열도록 함
     */
    toggleModal({
      name: 'rejectCancelModal',
      data: {
        orderItemList: targetOrderCancelItemList.map((item) => ({
          orderItemId: item.orderItemId,
          productName: item.productName,
          productPrice: item.productPrice,
        })),
      },
    });
  };

  /**
   *  취소 완료 처리전
   *  취소건에 대한 재고 및 상태 정보 가져오기
   */
  getOrderCancelStockAndStatusList = async () => {
    const { orderCancelManagement, getOrderCancelStockAndStatusList } = this.props;
    const { orderCancelManagementSelectedList, orderCancelManagementList } = orderCancelManagement;
    const { list } = orderCancelManagementList;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderCancelManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  상품 주문 취소 상태가 취소 요청(0)인 경우에만
     *  취소 거부 처리를 할 수 있음
     */
    const targetOrderCancelItemList = list.reduce((acc, item) => {
      if (
        orderCancelManagementSelectedList.includes(item.orderItemId) &&
        item.orderItemCancelStatus === ORDER_CANCEL_ITEM_STATUS.CANCEL_REQUEST
      ) {
        acc.push(item);
      }
      return acc;
    }, []);

    /**
     *  선택한 상품 주문서에 취소 요청(0)건이 없을 경우
     */
    if (!targetOrderCancelItemList.length) {
      await asyncSimpleModal({
        type: 'error',
        title: '취소 완료 처리',
        message: '취소 요청 상태의 주문만 적용할 수 있습니다.',
      });
      return;
    }

    /**
     *  선택한 상품 주문서에 취소 요청(0)건이 있을 경우
     *  확인을 누르면, 진행을 하고, 취소를 누르면 진행을 하지 않는다.
     */
    const completeCollectionConfirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '취소 완료처리',
      message:
        `선택하신 (${orderCancelManagementSelectedList.length}개) 상품 주문건 증 취소 완료처리가\n` +
        `가능한 상품 주문은 (${targetOrderCancelItemList.length}개)입니다.\n` +
        '진행하시겠습니까?',
      okText: '취소 완료처리',
    });

    /**
     *  선택된 취소 요청(0) 상품 리스트를
     *  서버로 전송해서 취소 완료처리로 업데이트함
     */
    if (completeCollectionConfirmResult) {
      getOrderCancelStockAndStatusList({
        orderItemIdList: targetOrderCancelItemList.map((item) => item.orderItemId),
      });
    }
  };

  /**
   *  취소 거부 -> 발송 처리
   *  [취소 거부(2)]
   */
  rejectOrderCancelDeliveryDispatch = async () => {
    const { orderCancelManagement, getDeliveryAgentList } = this.props;
    const { orderCancelManagementSelectedList, orderCancelManagementList } = orderCancelManagement;
    const { list } = orderCancelManagementList;

    /**
     * 선택된 상품 주문서가 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(
      orderCancelManagementSelectedList,
      INVALID_REQUIRED_SELECT_ORDER_ITEM_MESSAGE,
    );
    if (!isSelected) return;

    /**
     *  취소 거부 -> 발송 처리는 1 건씩만 가능합니다.
     */
    if (orderCancelManagementSelectedList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '취소 거부 -> 발송 처리',
        message: '취소 거부 -> 발송 처리는 1건씩만 가능합니다.',
      });
      return;
    }

    /**
     *  상품 주문 취소 상태가 취소 거부(2)인 경우에만
     *  취소 거부 처리를 할 수 있음
     */
    const targetOrderCancelItemList = list.reduce((acc, item) => {
      if (
        orderCancelManagementSelectedList.includes(item.orderItemId) &&
        item.orderItemCancelStatus === ORDER_CANCEL_ITEM_STATUS.CANCEL_REJECT
      ) {
        acc.push(item);
      }
      return acc;
    }, []);

    /**
     *  선택한 상품 주문서에 취소 거부(2)건이 없을 경우
     */
    const targetOrderCancelItem = targetOrderCancelItemList[0];
    if (!targetOrderCancelItem) {
      await asyncSimpleModal({
        type: 'error',
        title: '발송 처리',
        message: '취소 거부 상태의 주문만 적용할 수 있습니다.',
      });
      return;
    }

    getDeliveryAgentList({
      orderItemId: targetOrderCancelItem.orderItemId,
      productName: targetOrderCancelItem.productName,
      productPrice: targetOrderCancelItem.productPrice,
      buyerPhone: targetOrderCancelItem.buyerPhone,
      recipientPhone: targetOrderCancelItem.recipientPhone,
      address: {
        postCode: targetOrderCancelItem.shippingPostCode,
        line1: targetOrderCancelItem.shippingAddress1,
        line2: targetOrderCancelItem.shippingAddress2,
      },
      shippingMessage: targetOrderCancelItem.shippingMessage,
    });
  };

  render() {
    const { orderCancelManagement, setData } = this.props;

    return (
      <OrderCancelManagementListWrap
        orderCancelManagement={orderCancelManagement}
        setData={setData}
        getList={this.getList}
        getAllListExcelDownload={this.getAllListExcelDownload}
        getSelectedListExcelDownload={this.getSelectedListExcelDownload}
        onCheckOrderItem={this.onCheckOrderItem}
        rejectOrderCancel={this.rejectOrderCancel}
        getOrderCancelStockAndStatusList={this.getOrderCancelStockAndStatusList}
        rejectOrderCancelDeliveryDispatch={this.rejectOrderCancelDeliveryDispatch}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    orderCancelManagement: state.order.orderCancelManagement,
  };
};

const mapDispatchToProps = {
  setData: orderActions.setData,
  toggleModal: orderActions.toggleModal,
  getOrderCancelManagementList: orderActions.getOrderCancelManagementList,
  getOrderCancelManagementAllListExcelDownload: orderActions.getOrderCancelManagementAllListExcelDownload,
  getOrderCancelManagementSelectedListExcelDownload: orderActions.getOrderCancelManagementSelectedListExcelDownload,
  getDeliveryAgentList: orderActions.getDeliveryAgentList,
  getOrderCancelStockAndStatusList: orderActions.getOrderCancelStockAndStatusList,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderCancelManagementContainer);
